// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AwsKmsKeysIcon = createSvgIcon(
  <svg width={40} height={40} fill="none" viewBox="0 0 40 40">
    <path fill="url(#aws-kms-keys_svga)" d="M40 0H0v40h40z" />
    <svg width={28} height={28} x={6} y={6} viewBox="0 0 28 28">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M21.68 13.91h3.16v-1.26h-3.16zm0 5.69h3.16v-1.27h-3.16zm0 5.68h3.16v-1.26h-3.16zm5.06-1.9H28v3.23c0 .66-.54 1.2-1.2 1.2H12.78a1.2 1.2 0 0 1-1.2-1.2V23.4h1.26v3.15h13.9zm0-5.68H28v3.23c0 .66-.54 1.2-1.2 1.2H12.78a1.2 1.2 0 0 1-1.2-1.2V17.7h1.26v3.16h13.9zM28 11.67v3.48c0 .71-.54 1.29-1.2 1.29H12.78c-.66 0-1.2-.58-1.2-1.29v-.6h1.26v.63h13.89v-3.5c0-.18-.07-.28-.1-.3H18.9v-1.26h7.73c.75 0 1.36.7 1.36 1.55m-16.36-4a1.05 1.05 0 0 1-.37-1.45 1.05 1.05 0 0 1 1.45-.37 1.05 1.05 0 1 1-1.08 1.81M12.76 9a2.3 2.3 0 0 0 1.66-2.82A2.32 2.32 0 1 0 12.75 9m-1.93 3a.6.6 0 0 0-.7.29L3.95 22.73l-2.56.66-.12-2.17.79-1.32a.6.6 0 0 0 .07-.48l-.46-1.77 1.77-.45q.25-.06.39-.29l.88-1.5a.6.6 0 0 0 .07-.47l-.46-1.76 1.77-.46q.25-.06.39-.29l1.18-2a.6.6 0 0 0-.02-.67A5.43 5.43 0 1 1 10.83 12m7.08-1.87A6.7 6.7 0 0 0 14.45.42a6.6 6.6 0 0 0-7.42 1.97 6.7 6.7 0 0 0-.66 7.74l-.85 1.43-2.12.55a.63.63 0 0 0-.46.77L3.5 15l-.62 1.04-2.12.55a.63.63 0 0 0-.46.77l.55 2.12-.75 1.27q-.1.16-.09.35l.17 3.12a.63.63 0 0 0 .79.58l3.56-.91q.25-.07.39-.3l6.08-10.27c2.71.48 5.5-.8 6.92-3.19"
        clipRule="evenodd"
      />
    </svg>
    <defs>
      <linearGradient
        id="aws-kms-keys_svga"
        x1={0}
        x2={40.99}
        y1={0}
        y2={38.96}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "AwsKmsKeys",
);
export default AwsKmsKeysIcon;
